// MAIN COLORS DEFAULT
let colors = {
  primary : '#007bff',
  success : '#28C76F',
  danger  : '#EA5455',
  warning : '#FF9F43',
  dark    : '#1E1E1E',
}

// THEME CONFIG
export const themeConfig = {
  routerTransition  : "zoom-fade", 
  theme             : "light",    
}

// IRIS CONFIG
export const irisConfig = {
  customers      : "EXmfLlw8R4GrEDpKyU06",
  sites          : "YTFODmC8FCj0CFKVJKfT",
  menuHeader     : "RjVxg0lKt2zZNvE78vKg",
  menuFooter     : "RjVxg0lKt2zZNvE78vKg",
  googleAnalyticsID : "UA-188113171-1"
} 

import Vue from 'vue'
import Vuesax from 'vuesax'
Vue.use(Vuesax, { theme:{ colors } })
